import React, { useState } from "react";
import CoreInvoiceInput from "./core-invoice-input";
import OverlapingCoins from "../../assets/images/icons/overlaping-coins.svg";
import CircularLoader from "../../assets/images/icons/circular-spinner.svg";
import { appHelpers } from "../../_helpers";
import moment from "moment";
import axios from "axios";
import { commonService } from "../../_services";
import { alertActions, apiActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { store } from "react-notifications-component";
import { connect } from "react-redux";
import { invoiceCreationService } from "../../_services/invoiceCreation.service";

const OrganizationInvoiceFieldForm = (props) => {
  const {
    invoiceTableData,
    setInvoiceTableData,
    isFetchingServices,
    organizationSelfServiceTypes,
    invoiceCustomerData,
    user,
    dispatch,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isMakingPayment, setIsMakingPayment] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [stage, setStage] = useState(1);
  let source = axios.CancelToken.source();

  const handleProceed = () => {
    let payload = {
      invoiceDate: moment().format("YYYY-MM-DD"),
      revenueId: invoiceTableData?.serviceType,
      customerAIN: invoiceCustomerData.customerAIN,
      currencyId: 566,
      // TODO: remove the hardcoded values - locationId
      locationId: 9,
      name: invoiceCustomerData?.customerName,
      emails: invoiceCustomerData?.email,
      phone: invoiceCustomerData?.phone,
      address: invoiceCustomerData?.address,
      bills: [
        {
          description: invoiceTableData.description,
          quantity: invoiceTableData.quantity,
          rate: invoiceTableData.amount,
          amount:
            (parseInt(invoiceTableData.quantity) *
              parseFloat(invoiceTableData.amount)) |
            0,
        },
      ],
      RevenueGroupId: invoiceTableData?.revenueGroupId || null,
      rrr: "",
      enableCredit: false,
      userId: user.userId,
      checkSimilarInvoice: false,
      agencyId: user?.organizationId,
    };
    if (stage === 1) {
      setIsLoading(true);
      createInvoice(payload);
    }
    if (stage === 2) {
      setStage(2);
    }
  };

  const downloadInvoice = () => {
    setIsDownloading(true);
    let payload = { invoiceNumber: invoiceTableData?.invoiceNumber };
    commonService
      .downloadInvoice(payload, source.token)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          appHelpers.downloadFile(response.downloadUrl, "Invoice");
          setIsDownloading(false);
        } else {
          store.addNotification({
            title: "Error",
            message:
              res?.response?.message ||
              "An error occured please try again later",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
            },
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  const createInvoice = (payload) => {
    dispatch(alertActions.startRequest());
    commonService
      .createInvoice(payload, source.token)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          setInvoiceTableData((prev) => ({
            ...prev,
            invoiceNumber: response?.id,
            RRR: response?.paymentRef,
          }));
          setStage(2);
          store.addNotification({
            title: "Success",
            message:
              response?.message || "Successfully created invoice request",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 5000 },
          });
        } else {
          store.addNotification({
            title: "Error",
            message:
              res?.response?.message ||
              "An error occured please try again later",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
            },
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const makePayment = () => {
    const payload = {
      invNum: invoiceTableData?.invoiceNumber,
      agencyId: user?.organizationId,
    };
    setIsMakingPayment(true);
    dispatch(alertActions.startRequest());
    invoiceCreationService
      .getMakePaymentUrl(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          store.addNotification({
            title: "Success",
            message:
              response?.message || "Successfully initated payment request",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 5000 },
          });
          window.location.href =
            response?.invoice?.billerUrl || "/invoice-initation";
        } else {
          store.addNotification({
            title: "Error",
            message:
              res?.response?.message ||
              "An error occured please try again later",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
            },
          });
        }
      })
      .catch((err) => {
        // console.log(err);
      })
      .finally(() => {
        setIsMakingPayment(false);
      });
  };

  const getInitials = (phrase) => {
    if (!phrase) return "";
    return phrase
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join("");
  };

  return (
    <div className="organisation-invoice-request-form">
      <div>
        <div className="user-info-card">
          <p className="initials">
            {getInitials(invoiceCustomerData?.customerName || "")}
          </p>
          <div className="details">
            <p className="name">
              {invoiceCustomerData?.customerName || "-----"}
            </p>
            <p className="email">{invoiceCustomerData?.email || "-----"}</p>
          </div>
        </div>
        <hr />
        {stage === 1 ? (
          <>
            <CoreInvoiceInput
              isFetchingServices={isFetchingServices}
              invoiceTableData={invoiceTableData}
              setInvoiceTableData={setInvoiceTableData}
              serviceList={organizationSelfServiceTypes}
            />
          </>
        ) : (
          <div>
            <div className="invoice-ready-container">
              <div className="overlaping-coins">
                <img src={OverlapingCoins} alt="coins" />
              </div>
              <p className="invoice-heading">Your invoice is ready! 🎉</p>
              <p className="invoice-subtext">
                The invoice is ready. Download invoice or make payment
              </p>
              <div className="invoice-info-container">
                <p className="title">Invoice amount</p>
                <p className="amount">
                  {invoiceTableData?.quantity
                    ? "₦" +
                      appHelpers.numberWithCommasOnly(
                        invoiceTableData?.amount * invoiceTableData?.quantity
                      )
                    : "₦" +
                        appHelpers.numberWithCommasOnly(
                          invoiceTableData?.amount
                        ) || "-------"}
                </p>
                <p className="other-dets">
                  <span>Service type: </span>{" "}
                  {invoiceTableData?.serviceTypeName || "-------"}
                </p>
                <p className="other-dets">
                  <span>Invoice number: </span>{" "}
                  {invoiceTableData?.invoiceNumber || "-------"}
                </p>
              </div>
            </div>
            <div className="flexed-button-container">
              <button
                className="entity-auth-outline-button"
                onClick={downloadInvoice}
                disabled={isDownloading}
              >
                {isDownloading ? "Processing..." : "Download Invoice"}
              </button>
              <button
                className="entity-auth-button"
                onClick={makePayment}
                disabled={isMakingPayment}
              >
                {isMakingPayment ? "Processing..." : "Make payment"}
              </button>
            </div>
          </div>
        )}
      </div>
      <div>
        {stage === 1 && (
          <button
            className="entity-auth-button"
            disabled={
              isLoading ||
              !invoiceTableData?.serviceType ||
              !invoiceTableData?.quantity ||
              !invoiceTableData?.amount
            }
            onClick={handleProceed}
          >
            {isLoading ? "Processing..." : "Continue"}
          </button>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(OrganizationInvoiceFieldForm);
